import { defineComponent, openBlock, createElementBlock, normalizeClass, createVNode, unref, withCtx, createElementVNode, Fragment, renderList, toDisplayString, createCommentVNode } from "vue";
import { CdrContainer } from "@rei/cedar";
const _hoisted_1 = {
  class: "featured-specs__spec-list"
};
const _hoisted_2 = {
  key: 0,
  class: "featured-specs__name"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FeaturedSpecs",
  props: {
    featuredSpecs: {},
    isJustForMembers: {
      type: Boolean,
      default: false
    },
    showXlBreakpoint: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", {
        id: "product-featured-specs",
        class: normalizeClass(["featured-specs", {
          "featured-specs--jfm": _ctx.isJustForMembers,
          "featured-specs--xl": _ctx.showXlBreakpoint
        }]),
        "aria-label": "featured product specifications"
      }, [createVNode(unref(CdrContainer), {
        class: "featured-specs__container"
      }, {
        default: withCtx(() => [_cache[0] || (_cache[0] = createElementVNode("h2", {
          class: "featured-specs__header"
        }, " Key Details ", -1)), createElementVNode("div", _hoisted_1, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.featuredSpecs, (featuredSpec, index) => {
          return openBlock(), createElementBlock("div", {
            key: featuredSpec.name,
            class: normalizeClass(["featured-specs__item", {
              "featured-specs__item--jfm": _ctx.isJustForMembers
            }])
          }, [index <= 3 ? (openBlock(), createElementBlock("div", _hoisted_2, toDisplayString(featuredSpec.name), 1)) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(featuredSpec.values, (value) => {
            return openBlock(), createElementBlock("div", {
              key: value,
              class: "featured-specs__values"
            }, toDisplayString(value), 1);
          }), 128))], 2);
        }), 128))])]),
        _: 1,
        __: [0]
      })], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FeaturedSpecs2.mjs.map
